//****DAPP CUSTOMISATION****//

//PASTE CONTRACT ADDRESS BETWEEN QUOTES
export const contractAddress = "0x8066B5B8a523A308DCBD40482a7F3Ddee8fc6878";

export const whitelistAddress = "0xe152131b759595AcDCcf82F01289e1D643a3D771";

export const price = 60;





